import axios from 'axios';
import config from './config';

const API_URL = `${config.API_BASE_URL}/categories`;

export const fetchCategories = async (branchId) => {
  try {
    const url = branchId ? `${API_URL}?branchId=${branchId}` : API_URL;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching categories:', error);
    throw error;
  }
};


export const createCategory = async (categoryData) => {
  try {
    // Ensure CategoriesOrder is sent if present
    const response = await axios.post(API_URL, categoryData);
    return response.data;
  } catch (error) {
    console.error('Error creating category:', error);
    throw error;
  }
};

export const updateCategory = async (id, categoryData) => {
  try {
    // Ensure CategoriesOrder is sent if present
    const response = await axios.put(API_URL, { ...categoryData, id });
    return response.data;
  } catch (error) {
    console.error('Error updating category:', error);
    throw error;
  }
};

export const deleteCategory = async (id) => {
  try {
    const response = await axios.delete(`${API_URL}/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting category:', error);
    throw error;
  }
};
